import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export default function CreatePDFButton({onOpenPreview}: {onOpenPreview: () => void}): JSX.Element {
  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      size={ButtonSize.MINI}
      text="Create PDF"
      onClick={onOpenPreview}
    />
  );
}
